<style scoped>
    .topbar-wrapper {
        width: 7.5rem;
        position: fixed;
        top: 0;
        z-index: 5;
        text-align: center;
        font-size: .36rem;
        line-height: 1rem;
        background-color: #52C4F6;
    }
    .topbar {
        height: 1rem;
        position: relative;
        box-sizing: border-box;

        /*font-weight: bold;*/
        color: #fff;
    }
    .back {
        width: .25rem;
        height: 100%;
        position: absolute;
        left: .3rem;
    }
    .back::before,.back::after{
        content: "";
        width: .25rem;
        height: 1px;
        position: absolute;
        top: 50%;
        left: 0;
        background-color: #fff;
        transform-origin: left center;
        transform: translateY(-50%) rotate(-45deg);
    }
    .back::after{
        transform: translateY(-50%) rotate(45deg)
    }
    .mainBg {
        width: 7.5rem;
        min-height: 100vh;
        background: url("~assets/sexBg.png") no-repeat center/cover;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 1.44rem;
    }

    .contentBox {
        width: 6.74rem;
        padding: .46rem .24rem;
        background: #fff;
        border: .02rem solid rgba(125, 125, 125, 1);
        box-shadow: 0 .03rem .1rem 0 rgba(78, 78, 78, 0.19);
        border-radius: .3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: .4rem;
    }

    .scaleTitle {
        font-size: .36rem;
        font-weight: bold;
        color: #2D2D2D;
        margin-bottom: .3rem;
    }

    .who {
        font-size: .3rem;
        margin-bottom: .24rem;
        color: #808080;
    }

    .testTime {
        font-size: .3rem;
        color: #808080;
    }
    .r1{
        width: 2.86rem;
        height: .46rem;
        background: url("~assets/result1.png") no-repeat center/cover;
    }
    .r2{
        width: 2.86rem;
        height: .46rem;
        background: url("~assets/result2.png") no-repeat center/cover;
    }
    .r3{
        width: 4.04rem;
        height: .46rem;
        background: url("~assets/result3.png") no-repeat center/cover;
    }
    .resultTitle{
        margin-top: .3rem;
        margin-bottom: .4rem;
        color: #212121;
        font-size: .36rem;
        font-weight: bold;
    }
    .resultContent{
        color: #181818;
        font-size: .3rem;
        line-height: .4rem;
    }
    .synthetical{
        width: 100%;
        padding-top: .3rem;
    }
    .synthetical li{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: .02rem solid #D2D2D2;
        height: .6rem;
        font-size: .24rem;
        color: #222020;
    }
    .symptom{
        width: 1.7rem;
    }
    .explains{
        width: 1.84rem;
        text-align: right;
    }
    .explainBox{
        width: 100%;
    }
    .explainItem{
        margin-top: .35rem;
        font-weight:bold;
        color: #111111;
        line-height: .36rem;
    }
    .explainItem span{
        font-size: .28rem;
        color: #1D1D1D;
    }
    .checkState{
        font-size: .24rem;
        color: #FF2727;
        text-align: right;
    }
    .checkState.active{
        color: #90EE90;
    }
    .wxInfoBox{
        padding: .28rem .14rem;
        width: 6.71rem;
        box-sizing: border-box;
        border-radius: .1rem;
        background: #ECF8FE;
        display: flex;
    }
    .wxEr{
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-right: .2rem;
    }
    .er{
        width: 2.13rem;
        height: 2.13rem;
        background: url("~assets/er2.png") no-repeat center/cover;
        margin-bottom: .12rem;
    }
    .wxEr span{
        color: #323334;
        font-size: .24rem;
    }
    .wxInfo{
        color: #4F4F4F;
        font-size: .3rem;
        display: flex;
        flex-direction: column;

    }
    .wxInfo span{
        width: 2.62rem;
        height: .4rem;
        display: flex;
        padding-left:.18rem;
        align-items: center;
        color: #FFFFFF;
        font-size: .24rem;
        background: #2A2929;
        border-radius: .1rem;
        margin-top: .16rem;
    }
</style>
<template>
    <div style="min-height: 100vh;background: #fff;">
<!--        <topbar text="个人测评报告"></topbar>-->
        <div class="topbar-wrapper">
            <div class="topbar">
                <span class="back" @click="back"></span>
                个人测评报告
            </div>
        </div>
        <div class="mainBg">
            <div class="contentBox">
                <div class="scaleTitle">
                    {{scaleTitle}}
                </div>
                <div class="who" v-if="isCompanyId">测试者：{{nickName}}</div>
                <div class="testTime">测试时间：{{createTime | time}}</div>
            </div>
            <div class="contentBox">
                <div class="r1"></div>
                <div class="resultTitle">{{scaleInfoResult.level}}</div>
                <div class="resultContent" v-html="scaleInfoResult.content"></div>
            </div>
            <div class="contentBox" v-if="resultType===1">
                <div class="r2"></div>
                <ul class="synthetical">
                    <li style="color: #606060;border-bottom: solid 0.02rem #707070">
                        <span>综合项</span>
                        <span>常模（均分±标准差)</span>
                    </li>
                    <li v-for="item in scaleResultRoots.slice(0,5)">
                        <span class="symptom">{{item.symptom}}</span>
                        <span>{{item.resultScore}}</span>
                        <span class="explains">{{item.explains}}</span>
                    </li>
                    <li style="color: #606060;border-bottom: solid 0.02rem #707070;margin-top: .8rem">
                        <span class="symptom">因子项</span>
                        <span style="width: .5rem">得分</span>
                        <span style="width: .5rem">均分</span>
                        <span style="width: 1rem">诊断参考</span>
                    </li>
                    <li v-for="item in scaleResultRoots.slice(5,scaleResultRoots.length)">
                        <span class="symptom">{{item.symptom}}</span>
                        <span style="width: .5rem">{{item.resultScore}}</span>
                        <span style="width: .5rem">{{(item.resultScore/item.questionCount).toFixed(2)}}</span>
                        <span style="width: 1rem" class="checkState" :class="{active:item.checkState==='无症状'}">{{item.checkState}}</span>
                    </li>

                </ul>
            </div>
            <div class="contentBox" v-if="resultType===1">
                <div class="r3"></div>
                <ul class="explainBox">
                    <li class="explainItem" v-for="item in scaleResultRoots.slice(5,scaleResultRoots.length)">
                        <span>【{{item.symptom}}】：</span>
                        {{item.explains}}
                    </li>
                </ul>
            </div>
            <div class="contentBox" v-if="resultType===2">
                <div class="r2"></div>
                <ul class="synthetical">
                    <li style="color: #606060;border-bottom: solid 0.02rem #707070;margin-top: .8rem">
                        <span class="symptom">因子项</span>
                        <span style="width: .5rem">得分</span>
                        <span style="width: 3rem;text-align: right">诊断参考</span>
                    </li>
                    <li v-for="item in scaleResultRoots">
                        <span class="symptom">{{item.symptom}}</span>
                        <span style="width: .5rem">{{item.resultScore}}</span>
                        <span style="width: 3rem;text-align: right">{{item.remark}}</span>
                    </li>
                </ul>
            </div>
            <div class="contentBox" v-if="resultType===2">
                <div class="r3"></div>
                <ul class="explainBox">
                    <li class="explainItem" v-for="item in scaleResultRoots">
                        <span>【{{item.symptom}}】：</span>
                        {{item.explains}}
                    </li>
                </ul>
            </div>
<!--            <div class="wxInfoBox" v-if="isCompanyId">-->
<!--                <div class="wxEr">-->
<!--                    <div class="er"></div>-->
<!--                    <span>扫码添加助理微信</span>-->
<!--                </div>-->
<!--                <div class="wxInfo">-->
<!--                    如需心理治疗，请联系助理为您安排咨询师答疑解惑。学生帮扶价格咨询，节假日优惠价格咨询。-->
<!--                    <span>更多好处等你发现 ></span>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'
    import Vue from "vue"

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                testId: '',
                scaleInfoResult: '',
                scaleUserTestRecord: '',
                scaleResultRoots: '',
                createTime: '',
                nickName: '',
                scaleTitle: '',
                resultType: '',
                isCompanyId: true,
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            back(){
                // this.$router.push(`/`)
                history.back()
            },
            selectPayType(n) {
                this.choose = n
            },
            toAnswer() {
                this.$router.push(`/topic?scaleId=${this.$route.query.scaleId}&gender=${this.$route.query.gender}`)

            },

            async getScaleInfo() {
                let obj = {}
                obj.testId = this.testId;
                let data = await getSources("/bear-scale/api/scaleInfoQuestion/getScaleResult.json", obj);
                if (data.status === 0) {
                    this.scaleUserTestRecord = data.scaleResult.scaleUserTestRecord;
                    this.scaleInfoResult = data.scaleResult.scaleInfoResult;
                    this.scaleResultRoots = data.scaleResult.scaleResultRoots;
                    this.createTime = data.scaleResult.createTime;
                    this.nickName = data.scaleResult.nickName;
                    this.scaleTitle = data.scaleResult.scaleTitle;
                    this.resultType = data.scaleResult.resultType;
                    if(this.scaleResultRoots){
                        this.scaleResultRoots.forEach((item)=>{
                            if(item.resultScore/item.questionCount===1){
                                Vue.set(item, "checkState", '无症状');
                            }else if(item.resultScore/item.questionCount>1&&item.resultScore/item.questionCount<=2){
                                Vue.set(item, "checkState", '很轻');
                            }else if(item.resultScore/item.questionCount>2&&item.resultScore/item.questionCount<=3){
                                Vue.set(item, "checkState", '中等');
                            }else if(item.resultScore/item.questionCount>3&&item.resultScore/item.questionCount<=4){
                                Vue.set(item, "checkState", '偏重');
                            }else if(item.resultScore/item.questionCount>4&&item.resultScore/item.questionCount<=5){
                                Vue.set(item, "checkState", '严重');
                            }
                        })
                    }

                }
            },

            getCookie(key) {
                let cookieStr = document.cookie.split("; ");
                for (let i = 0; i < cookieStr.length; i++) {
                    let tempArr = cookieStr[i].split("=");
                    if (tempArr[0] == key) {
                        return tempArr[1];
                    }
                }
                return null;
            }
        },
        mounted() {
            this.testId=this.$route.query.testId;
            let status=JSON.parse(localStorage.getItem('scaleUser'));
            if(status){
                if(status.companyId){
                    this.isCompanyId=false;
                    // this.scaleUser=JSON.parse(localStorage.getItem('scaleUser'));
                    // this.roleMenuList=JSON.parse(localStorage.getItem('roleMenuList'));
                }
            }
            this.getScaleInfo()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/result.vue